export default __webpack_public_path__ + "assets/models/691a33e7c8fc19a6a92b82caa35c8298.glb";